export function normalizeTemplateName(name: string | null | undefined): string {
  return name?.replace(/\s*template[-_\s]*\S*/gi, '').trim() || '';
}
